import { useMemo } from 'react';
import { ChargeTest, RangeTest } from '@appTypes/carModelType';
import { Season } from '@appTypes/ElPrixContextData';
import { formatTestSeason, groupRangeTests } from './RangeTests.utils';
import { useTestTabSelection } from './useTestTabSelection';

export const useRangeTestGroups = (rangeTests: RangeTest[], chargeTests?: ChargeTest[]) => {
  const testGroups = useMemo(() => groupRangeTests(rangeTests, chargeTests), [rangeTests, chargeTests]);
  // Entries rather than keys, so each context carries its own tests — indexing `testGroups` by a
  // plain string back at the call site loses the template-literal key type.
  const tabContexts = useMemo(
    () =>
      Object.entries(testGroups)
        .sort(([a], [b]) => new Date(b.split('_')[1]).getTime() - new Date(a.split('_')[1]).getTime())
        .map(([key, { tests }]) => {
          const [season, date] = key.split('_') as [Season, string];
          return { key, value: formatTestSeason(season, date), tests };
        }),
    [testGroups],
  );

  const { selectedTab, selectTabByKey } = useTestTabSelection(tabContexts);

  return { testGroups, tabContexts, selectedTab, selectTabByKey };
};
